





































import { Component, Vue } from 'vue-property-decorator';
import FilterButton from '../filterbutton';
import { Icon } from '@/pages/profile/components';
import { FilterTypeEnum } from './types';

@Component({
  components: {
    FilterButton,
    Icon,
  },
})
export default class FilterBottonsBlock extends Vue {
  isRoomsType: boolean = false;
  isLessonsType: boolean = false;
  isTestsType: boolean = false;
  isExaminationType: boolean = false;

  selectedType(value: string) {
    if (FilterTypeEnum.ROOMS_TYPE === value)
      this.isRoomsType = !this.isRoomsType;
    if (FilterTypeEnum.LESSONS_TYPE === value)
      this.isLessonsType = !this.isLessonsType;
    if (FilterTypeEnum.TESTS_TYPE === value)
      this.isTestsType = !this.isTestsType;
    if (FilterTypeEnum.EXAMINATION_TYPE === value)
      this.isExaminationType = !this.isExaminationType;
    this.$emit('selectedType', value);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/remote-edu/calendar/components/calendarfilter/components/filterbottonsblock/FilterBottonsBlock.vue